<!-- 关联附件弹框H5 -->
<template>
  <van-popup v-model="showPopup" round position="bottom" class="container" @close="close">
    <div class="btnRow">
      <van-button size="mini" class="cancelBtn" @click="showPopup = false">取消</van-button>
      <van-button size="mini" class="submitBtn" @click="submit">确定</van-button>
    </div>
    <template v-if="showPopup">
      <el-tree
        ref="treeH5"
        lazy
        accordion
        :props="props"
        :load="load"
        :node-key="props.value"
        :default-expanded-keys="defaultExpandedKey"
        :show-checkbox="checkbox"
        @check="checkChange"
      >
        <template #default="{ data }">
          <div class="treeItem">
            <img :src="className(data)" class="img" alt="" />
            <span class="fileName">{{ data.folderName }}</span>
          </div>
        </template>
      </el-tree>
    </template>
  </van-popup>
</template>

<script>
import { mapState } from "vuex";
import { Notify } from "vant";
import { tableRowIcon } from "@/CommonDP/utils/docPublic";

export default {
  emits: ["check-change"],
  props: {
    props: {
      type: Object,
      default: () => {
        return {
          value: "folderId", // ID字段名
          label: "folderName", // 显示名称
          children: "childList", // 子级字段名
          isLeaf: "leaf"
        };
      }
    },
    load: {
      type: Function,
      default: () => {}
    }, // 懒加载方法
    checkbox: {
      type: Boolean,
      default: true
    } // 复选框
  },
  components: {},
  data() {
    return {
      showPopup: false, // 弹框显隐
      defaultExpandedKey: [],
      curChecked: [] // 当前复选框
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  mounted() {},
  methods: {
    // 图标
    className(row) {
      return tableRowIcon(row);
    },

    // 复选框改变
    checkChange(val, currentChecked) {
      this.curChecked = currentChecked.checkedNodes;
    },
    // 确定提交
    submit() {
      if (this.checkbox) {
        if (!this.curChecked?.length) return Notify({ type: "warning", message: "选中的文件为空" });
        this.$emit("check-change", this.curChecked);
        this.showPopup = false;
      }
    },

    // 关闭事件
    close() {
      this.curChecked = [];
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 10px 5px;

  .btnRow {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .cancelBtn {
      border: none;
      color: #909399;
    }
    .submitBtn {
      border: none;
      color: var(--theme-color);
    }
  }

  .el-tree {
    width: 100%;
    min-height: 300px;
    max-height: 60vh !important;
    overflow-y: auto;
  }
}

.treeItem {
  width: 100%;
  display: flex;
  align-items: center;

  .img {
    margin-right: 5px;
  }
  .fileName {
    width: 1px;
    flex-grow: 1;
    overflow-x: auto;
  }
}

::-webkit-scrollbar {
  display: none;
}
</style>
